import React, { useState } from "react";

const scrollbarStyles = `
  .products-scroll::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  .products-scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const Products = ({ card, onBack, onSendPackage }) => {
  const [selectedCookie, setSelectedCookie] = useState("Choose an Option");
  const [smallQuantity, setSmallQuantity] = useState(1);
  const [showSmallDropdown, setShowSmallDropdown] = useState(false);
  const [quantity, setQuantity] = useState("Choose an Option");
  const [showCookieDropdown, setShowCookieDropdown] = useState(false);
  const [showQuantityDropdown, setShowQuantityDropdown] = useState(false);

  const cookieOptions = [
    "One Way",
    "Round Trip",
    "Inbound",
    "Outbound",
  ];

  const kindOptions = ["Consult", "Purchase", "Installation", "Removal", "Repair"];

  const quantityOptions = [1, 2, 3];

  const serviceDescriptions = {
    "Car Shipment":
      "Help coordinating safe and reliable transport of a student’s car to or from home – especially when you can't be there.",
    "Broken Device Repair":
      "Quick assistance arranging repair or replacement of phones, laptops, and tablets. Includes pick up and drop off. Excludes actual repair cost.",
    "Airport Shuttle":
      "Convenient, trustworthy, door-to-door rides for students heading to or from the airport during breaks.",
    "Notary Service":
      "On-call help connecting students and families with a local notary for official forms and documents.",
    "Event Planning":
      "Support for organizing on-campus gatherings, club events, or personal celebrations.",
    "Pack & Move":
      "Hands-on help with packing, moving, or storing dorm and apartment belongings.",
    "Wardrobe Consult":
      "Personalized style advice or outfit coordination for interviews, presentations, or special events. Includes shopping assistance.",
    "Urgent Care Assistance":
      "Help finding and coordinating transportation to nearby medical clinics when a student isn’t feeling well.",
    "TV Install/Removal":
      "Setup or removal service for dorm and apartment TVs or streaming devices.",
    "Grocery Shopping":
      "Personalized grocery runs to stock dorm fridges or apartments with all the essentials and more.",
    "Summer Storage Assistance":
      "Support arranging pick-up, storage, and return of belongings during summer break.",
    "Dorm/Apt Organization":
      "Decluttering and setup assistance to make dorms or apartments functional and comfortable.",
    "Dorm Makeover":
      "Decorating support to personalize a space and make it feel like home.",  
  };

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <style>{scrollbarStyles}</style>
    
      {/* Fixed Top Section */}
      <div style={{ flex: "0 0 auto", padding: "24px 12px 24px 12px" }}>
        <h2
          style={{
            color: "#FFFFFF", 
            fontFamily: "Manrope",
            fontSize: "28px",
            fontWeight: 600,
            margin: 0,
          }}
        >
          Get a Hand
        </h2>

        {/* Back Arrow below the title */}
        <div
          onClick={onBack}
          style={{
            cursor: "pointer",
            marginTop: "12px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="14"
            viewBox="0 0 9 14"
            fill="none"
          >
            <path
              d="M7.5 1L1.5 7L7.5 13"
              stroke="#F5F3ED"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      {/* Scrollable Content */}
      <div
        className="products-scroll"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflowY: "auto",
          padding: "0 12px 24px 12px", //  matches ServicesSidebar spacing
        }}
      >

        {/* Product Image */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              background: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(30px)",
              padding: "16px",
              width: "390px",
              height: "250px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              src={card.image}
              alt={card.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: "16px",
                transform: "rotate(40deg) translateY(-18px)",
                transition: "transform 0.3s ease",
              }}
            />
          </div>
        </div>

        {/* Product Details */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "16px" }}>
          <div
            style={{
              fontWeight: 700,
              fontSize: "18px",
              lineHeight: "120%",
              color: "#FFF",
            }}
          >
            {card.title}
          </div>
          <div
            style={{
              fontSize: "15px",
              fontWeight: 400,
              color: "#FFF",
            }}
          >
            From:{" "}
            <span style={{ fontWeight: 700, fontSize: "18px" }}>{card.price}</span>
          </div>
          <div
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 11,
              overflow: "hidden",
              color: "#FFF",
              fontSize: "15px",
            }}
          >
            {serviceDescriptions[card.title] ||
              "Explore our helpful student service packages designed for your convenience."}
          </div>

          {/* Size Dropdown */}
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              width: "100%",
            }}
          >
            <div style={{ fontSize: "12px", fontWeight: 400, color: "#FFF" }}>Direction</div>

            <div
              onClick={() => setShowCookieDropdown(!showCookieDropdown)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 10px",
                borderRadius: "8px",
                border: "1px solid #E6E6E6",
                background: "rgba(255, 255, 255, 0.20)",
                backdropFilter: "blur(20px)",
                cursor: "pointer",
              }}
            >
              <span style={{ color: "#FFF", fontFamily: "Manrope", fontSize: "14px", fontWeight: 400 }}>
                {selectedCookie}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M2.91406 4.16602L4.9974 6.24935L7.08073 4.16602H2.91406Z" fill="white" />
              </svg>
            </div>

            {showCookieDropdown && (
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid #E6E6E6",
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(30px)",
                  padding: "4px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                {cookieOptions.map((cookie) => (
                  <div
                    key={cookie}
                    onClick={() => {
                      setSelectedCookie(cookie);
                      setShowCookieDropdown(false);
                    }}
                    style={{
                      padding: "8px 10px",
                      color: "#FFF",
                      fontFamily: "Manrope",
                      fontSize: "14px",
                      cursor: "pointer",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.25)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    {cookie}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Quantity Dropdown */}
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              width: "100%",
            }}
          >
            <div style={{ fontSize: "12px", fontWeight: 400, color: "#FFF" }}>Kind</div>

            <div
              onClick={() => setShowQuantityDropdown(!showQuantityDropdown)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 10px",
                borderRadius: "8px",
                border: "1px solid #E6E6E6",
                background: "rgba(255, 255, 255, 0.20)",
                backdropFilter: "blur(20px)",
                cursor: "pointer",
              }}
            >
              <span style={{ color: "#FFF", fontFamily: "Manrope", fontSize: "14px", fontWeight: 400 }}>
                {quantity}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M2.91406 4.16602L4.9974 6.24935L7.08073 4.16602H2.91406Z" fill="white" />
              </svg>
            </div>

            {showQuantityDropdown && (
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid #E6E6E6",
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(30px)",
                  padding: "4px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                {kindOptions.map((num) => (
                  <div
                    key={num}
                    onClick={() => {
                      setQuantity(num);
                      setShowQuantityDropdown(false);
                    }}
                    style={{
                      padding: "8px 10px",
                      color: "#FFF",
                      fontFamily: "Manrope",
                      fontSize: "14px",
                      cursor: "pointer",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.25)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    {num}
                  </div>
                ))}
              </div>
            )}
          </div>

          <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 20px",
              borderRadius: "17px",
              border: "none",
              background: "rgba(255, 255, 255, 0.15)",
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              fontWeight: 700,
              cursor: "pointer",
              width: "100%",
              marginTop: "16px",
            }}
          >
            Make Custom
          </button>

          {/* Add to Order */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              borderRadius: "18px",
              border: "1px solid #E6E6E6",
              background: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(30px)",
              width: "100%",
              marginTop: "24px",
              gap: "12px",
            }}
          >
            <div
              style={{
                fontSize: "16px",
                fontWeight: 700,
                color: "#FFF",
                letterSpacing: "-0.36px",
                flexShrink: 0,
              }}
            >
              {card.price}
            </div>

            {/* Small Quantity */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                width: "46px",
                flexShrink: 0,
                position: "relative",
              }}
            >
              <div
                onClick={() => setShowSmallDropdown(!showSmallDropdown)}
                style={{
                  display: "flex",
                  padding: "8px 10px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "4px",
                  borderRadius: "8px",
                  border: "1px solid #E6E6E6",
                  background: "rgba(255, 255, 255, 0.20)",
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    color: "#FFF",
                    fontFamily: "Manrope",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "120%",
                    letterSpacing: "-0.28px",
                    textAlign: "center",
                    flex: 1,
                  }}
                >
                  {smallQuantity}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                >
                  <path
                    d="M2.91406 4.16602L4.9974 6.24935L7.08073 4.16602H2.91406Z"
                    fill="white"
                  />
                </svg>
              </div>

              {showSmallDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "50px",
                    left: 0,
                    borderRadius: "8px",
                    border: "1px solid #E6E6E6",
                    background: "rgba(255, 255, 255, 0.15)",
                    backdropFilter: "blur(30px)",
                    zIndex: 10,
                    padding: "4px 0",
                    width: "46px",
                  }}
                >
                  {quantityOptions.map((num) => (
                    <div
                      key={num}
                      onClick={() => {
                        setSmallQuantity(num);
                        setShowSmallDropdown(false);
                      }}
                      style={{
                        padding: "8px 10px",
                        color: "#FFF",
                        fontFamily: "Manrope",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "background 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background =
                          "rgba(255,255,255,0.25)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      {num}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              onClick={() =>
                onSendPackage({ ...card, selectedCookie, quantity: smallQuantity })
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                borderRadius: "17px",
                border: "none",
                background: "#7EB3AB",
                color: "#FFF",
                fontFamily: "Manrope",
                fontSize: "15px",
                fontWeight: 700,
                cursor: "pointer",
                flexShrink: 0,
              }}
            >
              Add to Order
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
